<template>
  <app-base-main
      parentTable
      :no-padding="!padding"
      :table-shadow="tableShow">
    <template #filter-group>
      <market-analysis-filter
          ref="marketFilter"
          :query-loading="queryBtnLoading"
          :paginations="pagination"
          @set-pagination="setPagination"
          @reset="reset"
          @search="search">
        <template #right>
          
           <!-- :download="$permission('storeAnalyze:export')" -->
          <gj-tool-group
              setting help
              :download="$permission('listingStatistics:export')"
              :download-params="globalParams"
              download-url="/operation/storeAnalyze/show/export"
              :table-name="tableName"
              :table-columns="columns"
              :sort-gjtable="$refs.gjTable"
          ></gj-tool-group>
        </template>
      </market-analysis-filter>
    </template>
    <!-- <template #operate-group>
      <gj-button
      type="primary"
      v-if="$permission('storageCostBatch:recalculate')"
      @click="importReport()" > 导入业务报告 </gj-button>
    </template> -->
    <template #table>
      <analysis-table
          ref="gjTable"
          adaptParent
          :data="data"
          :columns="columns"
          :loading="loading"
          :query-params="params"
          :summary-object="summaryObject"
          :params="params"
          show-summary
          :pagination="pagination"
          :loop_fields="loopFields"
          @sort-change="$gjSortChange"
          @page-change="pageChange"
      ></analysis-table>
    </template>
  </app-base-main>
</template>

<script>
  import {analysisFields, marketField, loop_fields} from "./analysis-fields-new";
  // import {analysisFields, marketField} from "../analysis-fields";
  import MarketAnalysisFilter from "./market-analysis-filter";
  import AnalysisTable from "./analysis-table-new";
  // import AnalysisTable from "../analysis-table";
  import {getMarketPerformedAnalysis} from "@/api/statistics";
  import {queryMixin, noRepeatQueryMixin} from "@/minxins";
  import {analysisMixin} from "modules/statistics/common/analysis/mixins";
  import Recalculation from "./modal/market-analysis-performance-model.vue";

  export default {
    name: "app-market-analysis-performance",
    components: {AnalysisTable, MarketAnalysisFilter},
    mixins: [queryMixin, analysisMixin, noRepeatQueryMixin],
    data() {
      return {
        tableName: 'marketAnalysisPerformance',
        data: [],
        columns: [
          ...marketField,
          {id: 'fulfillableQuantity', field: 'slot:fulfillableQuantity', header: 'FBA可售', help: '当前FBA仓库可售量', summary: true, minWidth: '120px', default: false},
          {id: 'saleableTurnover', field: 'slot:saleableTurnover', header: 'FBA可售周转', help: 'FBA可售周转=FBA可售/7天日均销量', summary: true, minWidth: '120px', default: false},
          {id: 'fulfillableQuantityFBM', field: 'slot:fulfillableQuantityFBM', header: 'FBM可售', help: '当前FBM仓库可售量',  summary: true, minWidth: '120px', default: false},
          {id: 'saleableTurnoverFBM', field: 'slot:saleableTurnoverFBM', header: 'FBM可售周转', help: 'FBM可售周转=FBM可售/7天日均销量', summary: true, minWidth: '120px', default: false},
          {id: 'fulfillableQuantityAmount', field: 'fulfillableQuantityAmount', header: '可售货值',summary: true,prefix: 'currencySymbol', align: 'right', sortable: false, minWidth: '120px', default: false},
          ...analysisFields('market'),
        ],
        params: {},
        summaryObject: null,
        filterStoragekey: 'MARKET_ANALYSIS_FILER_marketAnalysis',
        loopFields: loop_fields
      }
    },
    created() {
      this.sort.prop = 'unitsOrdered';
    },
    methods: {
      pageChange() {
        this.$refs.marketFilter.setCacheDatas()
        this.$gjNoticeQuery('page')
      },
      setPagination(pages) {
        this.pagination.pageSize = pages.pageSize || 20
      },
      $gjQuery() {
        this.loading = true;
        this.queryBtnLoading = true
        let params = {
          model: this.params,
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        getMarketPerformedAnalysis(params)
          .then((data) => {
            this.data = data.records;
            this.summaryObject = data.statisticRecord;
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.queryBtnLoading = false
            this.loading = false
          });
      },
      reset(params) {
        this.params = params
        this.pagination.currentPage = 1;
        // localStorage.removeItem('CACHE_MARKET_ANALYSIS_FILER_marketAnalysis')
        this.$gjReset()
      },
      search(params) {
        this.params = params;
        this.pagination.currentPage = 1;
        this.$gjNoticeQuery();
      },
      // 导入业务报告
      importReport() {
        this.$gjCreate(Recalculation, {
          // props: {},
          // on: {
          //   creact: this.$gjQuery
          // }
        });
      },
    }
  }
</script>

<style scoped>

</style>
